// extracted by mini-css-extract-plugin
export default {"hero":"Start_hero__Aa5i2","text":"Start_text__8ndNL"};